import {Base} from "@/api/Base"

export class ReportBatchDelete extends Base {
    path = "report/batchDelete"
}